import type { FormTarget, OrderAttribute } from "@jti/magento";

const orderConfirmationPlacement: FormTarget = "buttonPlaceOrder_before";

/**
 * Checks whether a required order attribute blocks shipping fast flow.
 * Attributes in the order-confirmation slot are collected after fast flow,
 * so they do not block it.
 */
export const hasRequiredOrderAttribute = (definedAttributes: OrderAttribute[] | undefined): boolean => {
  if (!definedAttributes || definedAttributes.length === 0) return false;

  return definedAttributes.some(
    (attribute) => attribute.is_required && attribute.placement !== orderConfirmationPlacement
  );
};
